module.exports = __webpack_public_path__ + "img/Naristagram.47618e83.png";